import { useLocation, useNavigate } from "react-router-dom";
import { createDiscountType, discountListType, FormValues, insuranceListType } from "./types";
import { useState } from "react";
import { useMutation, useQuery } from "react-query";
import { createDiscount, deleteDiscount, getDiscountById } from "./service";
import { getAllCptGrpups } from "../insurancePriceMaster/service";
import { ArrowBack, Close, Save } from "@mui/icons-material";
import { Paper, Typography, Button, Divider, TableContainer, Table, TableHead, TableRow, TableCell, IconButton, CircularProgress, Switch } from "@mui/material";
import { base, clinicId } from "../../../constants";
import moduleRoutes from "../../../routes/moduleRouteList";
import CustomTableBody from "../../../utilis/component/CustomTableBody";
import mastersRouteList from "../../routeList";
import { CustomFormField } from "../../../utilis/component/CustomFormElement";
import { useForm } from "react-hook-form";
import usePopup from "../../../hooks/usePopup";
import insuanceMatserRouteList from "../routeList";
import useAuthentication from "@hooks/useAuthentication";
const AddOrEdit = () => {
    const pageTitle = "Discount";

    const location = useLocation() as { state?: { data?: any } };
    const refdata: insuranceListType | null = location.state?.data ?? null;
    const navigate = useNavigate();
    const {user} = useAuthentication()

    const { control, reset, handleSubmit } = useForm<FormValues>({
        defaultValues: {
            cptGroupName: null,
            discount: null,
            status: 1,
            id: 0,
        },
        mode: "onChange",
        reValidateMode: "onChange",
    });
    const [success, setSuccess] = useState<boolean>(false);
    const { showSnackbar } = usePopup();
    const [selected, setSelected] = useState<number | null>(null);

    const { data: tableData, isFetching: tableDataLoading } = useQuery(
        ["",success],
        async () => getDiscountById({ id: refdata?.insuranceId as number, clinicId }),
        {
            refetchOnWindowFocus: false,
        }
    );


    const { data: groupList } = useQuery(["getallpricelistcptLoading"], () => getAllCptGrpups());
    const { mutate: AddDiscount, isLoading } = useMutation(createDiscount, {
        onSuccess: (result) => {
            setSuccess(!success)
            reset({
                cptGroupName: null,
                discount: null,
                status: 1,
            });
            if (result.responseIndicator == "success") {
                showSnackbar({
                    message: result.responseMessage,
                    open: true,
                    variant: "success",
                    duration: 3000,
                });
            } else {
                showSnackbar({
                    message: result.responseMessage,
                    open: true,
                    variant: "warning",
                    duration: 3000,
                });
            }
        },
        onError: (e: any) => {
            showSnackbar({
                message: e?.response?.data?.responseMessage || "Something went wrong!",
                open: true,
                variant: "error",
                duration: 3000,
            });
        },
    });

    const { mutate: deleteData } = useMutation(deleteDiscount, {
        onSuccess: (result: any) => {
            setSuccess(!success);
            if (result.responseIndicator == "success") {
                showSnackbar({
                    message: result.responseMessage,
                    open: true,
                    variant: "success",
                    duration: 3000,
                });
            } else {
                showSnackbar({
                    message: result.responseMessage,
                    open: true,
                    variant: "warning",
                    duration: 3000,
                });
            }
        }
    })
    const handleReset = () => {
        reset({
            cptGroupName: null,
            discount: null,
            status: 1,
        });
    };
    const onsubmit = (data: any) => {
        console.log("data",data);
        
        const params: createDiscountType = {
            clinicId,
            cptGroupId: data.cptGroupName.cptGroupId as number,
            createById: Number(user?.userId),
            discount: Number(data.discount),
            id: data?.id || 0,
            insuranceId: refdata?.insuranceId as number,
            status:Number(data.status) ? 1 : 0,
        };
        AddDiscount(params);
    };
    const handleUpdateOneStatus = (
        status: boolean,
        data: discountListType
    ) => {
        setSelected(data.cptGroupId);
        const params: createDiscountType = {
            clinicId,
            cptGroupId: data.cptGroupId as number,
            createById: Number(user?.userId),
            discount: Number(data.discount),
            id: data?.id || 0,
            insuranceId: refdata?.insuranceId as number,
            status: status ? 1 : 0
        };
        AddDiscount(params);
    };

    return (
        <div className="p-3">
            <Paper>
                <div className="flex justify-between p-3">
                    <div className="flex gap-2">
                        <Typography variant="h6" color={"default"}>
                            {pageTitle} Master
                        </Typography>
                    </div>
                    <Button
                        color="error"
                        startIcon={<ArrowBack />}
                        onClick={() => {
                            navigate(
                                `${base}${moduleRoutes.mainRoute}/${moduleRoutes.masters}/${mastersRouteList.insuranceMaster}/${insuanceMatserRouteList.insuranceDiscount}`
                            );
                        }}
                    >
                        BACK
                    </Button>
                </div>
                <Divider />
                <form onSubmit={handleSubmit(onsubmit)} className="p-3">
                    <div className="flex justify-between items-center p-2">
                        <div>
                            <Typography variant="h6" className="p-3">
                                Add {pageTitle}
                            </Typography>
                        </div>
                        <div className="flex gap-2">

                            <Button
                                disabled={isLoading}
                                color="error"
                                type="reset"
                                onClick={handleReset}
                                startIcon={<Close />}
                            >
                                reset
                            </Button>

                            <Button
                                disabled={isLoading}
                                type="submit"
                                color="success"
                                startIcon={
                                    isLoading ? (
                                        <CircularProgress size={20} color="success" />
                                    ) : (
                                        <Save />
                                    )
                                }
                            >
                                save
                            </Button>
                        </div>
                    </div>
                    <div className="grid grid-cols-12 gap-4">
                        <div className="col-span-4">
                            <CustomFormField
                                control={control}
                                name="cptGroupName"
                                element="autocomplete"
                                fieldProps={{ label: "CPT Group Name" }}
                                options={groupList?.response || []}
                                autocompleteProps={{
                                    isOptionEqualToValue: (option, value) => option.cptGroupName === value.cptGroupName,
                                    getOptionLabel: (option) => option.cptGroupName || "",
                                }}
                                rules={{ required: "CPT Group Name is required" }}
                            />
                        </div>
                        <div className="col-span-4">
                            <CustomFormField
                                control={control}
                                name="discount"
                                element="input"
                                fieldProps={{ label: "Discount", type: "number" }}
                                rules={{ required: "Discount is required" }}
                            />
                        </div>
                        <div className="col-span-4">
                            <CustomFormField
                                control={control}
                                name="status"
                                element="radio"
                                radioProps={{ row: true }}
                                radios={[
                                    { label: "Active", value: 1 },
                                    { label: "Inactive", value: 0 },
                                ]}
                                fieldProps={{ label: "Status " }}
                                rules={{ required: "Plan status is required" }}
                            />

                        </div>
                    </div>
                </form>
                <TableContainer className="border">
                    <Table stickyHeader size="small">
                        <TableHead>
                            <TableRow>
                                {headings.map((heading) => (
                                    <TableCell key={heading} className="font-bold">
                                        {heading}
                                    </TableCell>
                                ))}
                                <TableCell className="font-bold">Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <CustomTableBody
                            alert={"No data"}
                            dataLoading={tableDataLoading}
                            isData={Boolean(tableData?.response?.items?.length)}
                            totalSpan={{
                                row: 4,
                                col: headings.length + 1,
                            }}
                        >
                            {tableData?.response?.items?.map((tableItem: discountListType, index: number) => (
                                <TableRow key={`${pageTitle}-${index}`}>
                                    <TableCell>{tableItem?.cptGroupName}</TableCell>
                                    <TableCell>{tableItem?.discount}</TableCell>
                                    <TableCell>
                                        <span className={`font-bold ${tableItem?.status ? "text-green-600" : "text-red-600"}`}>
                                            {tableItem?.status ? "Active" : "InActive"}
                                        </span>
                                    </TableCell>
                                    <TableCell>
                                        <div className="flex gap-2">
                                            <IconButton
                                                color="error"
                                                onClick={() => {
                                                    deleteData(tableItem?.id);
                                                }}
                                            >
                                                <Close />
                                            </IconButton>
                                            {(isLoading && tableItem?.cptGroupId == selected) && <CircularProgress sx={{ marginTop: "10px" }} size={18} />}
                                            <Switch
                                                checked={Boolean(tableItem.status)}
                                                disabled={isLoading && tableItem?.cptGroupId == selected}
                                                onChange={(e) => {
                                                    handleUpdateOneStatus(e.target.checked, tableItem);
                                                }}
                                            />
                                        </div>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </CustomTableBody>
                    </Table>
                </TableContainer>
            </Paper>
        </div>
    );
};

export default AddOrEdit;

export const headings = [
    "CPT Group Name",
    "Discount",
    "Status",
];